/* Ludidoo round 12 – product page helpers (loaded only on product pages, defer).
   1 sticky bottom bar on phones · 2 gallery counter, dots and swipe hint · 4 free-shipping line refresh.
   Also measures the Pandectes cookie bar so the sticky bar and the scroll-to-top button sit above it. */
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width: 749px)');
  var root = document.documentElement;
  var ccH = 0, stickyH = 0;

  function setOffsets() {
    root.style.setProperty('--ld-cc-h', ccH + 'px');
    root.style.setProperty('--ld-bottom-offset', (ccH + stickyH) + 'px');
  }

  /* ---------- cookie bar height (Pandectes) ---------- */
  function measureCookie() {
    var w = document.querySelector('#pandectes-banner .cc-window');
    var h = 0;
    if (w && !w.classList.contains('cc-invisible')) {
      var cs = getComputedStyle(w);
      if (cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.05) {
        var r = w.getBoundingClientRect();
        if (r.height > 0 && r.top < window.innerHeight) h = Math.max(0, Math.round(window.innerHeight - r.top));
      }
    }
    if (!mq.matches) h = 0;
    if (h !== ccH) { ccH = h; setOffsets(); }
  }
  function watchCookie() {
    var banner = document.getElementById('pandectes-banner');
    if (!banner) return false;
    new MutationObserver(function () { requestAnimationFrame(measureCookie); })
      .observe(banner, { attributes: true, childList: true, subtree: true, attributeFilter: ['class', 'style'] });
    if ('ResizeObserver' in window) {
      var w = banner.querySelector('.cc-window');
      if (w) new ResizeObserver(function () { measureCookie(); }).observe(w);
    }
    banner.addEventListener('transitionend', measureCookie);
    measureCookie();
    return true;
  }
  if (!watchCookie()) {
    var bodyObs = new MutationObserver(function () { if (watchCookie()) bodyObs.disconnect(); });
    bodyObs.observe(document.body, { childList: true });
    setTimeout(function () { bodyObs.disconnect(); }, 20000);
  }

  /* ---------- 1. sticky bottom bar ---------- */
  var bar = document.getElementById('sticky-cta');
  var mainBtn = document.querySelector('.section-product-page [data-ld-buy] .product-form__submit');
  if (bar && bar.classList.contains('ld-sticky') && mainBtn) {
    /* A scroll check, not an IntersectionObserver: a fast scroll can jump from "below the screen" to "above the screen"
       without the button ever intersecting, and the observer would then never fire. */
    var lastOn = null, ticking = false;
    var check = function () {
      ticking = false;
      var on = mq.matches && mainBtn.offsetParent !== null && mainBtn.getBoundingClientRect().bottom < 0;
      if (on === lastOn) return;
      lastOn = on;
      bar.classList.toggle('ld-sticky--on', on);
      document.body.classList.toggle('ld-sticky-on', on);
      stickyH = on ? Math.round(bar.getBoundingClientRect().height) : 0;
      setOffsets();
    };
    var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    mq.addEventListener ? mq.addEventListener('change', onScroll) : mq.addListener(onScroll);
    check();
  }

  /* ---------- 2. gallery counter, dots, swipe hint ---------- */
  document.querySelectorAll('.section-product-page media-gallery').forEach(function (gal) {
    var list = gal.querySelector('.product__media-list');
    var cur = gal.querySelector('[data-ld-gal-cur]');
    if (!list || !cur) return;
    var dots = gal.querySelectorAll('.ld-gal-dots span');
    var hint = gal.querySelector('[data-ld-gal-hint]');
    var slides = function () {
      return Array.prototype.filter.call(list.querySelectorAll('[id^="Slide-"]'), function (li) { return li.clientWidth > 0; });
    };
    var last = -1, ticking = false;
    var hideHint = function () { if (hint && !hint.classList.contains('is-gone')) { hint.classList.add('is-gone'); setTimeout(function () { hint.hidden = true; }, 450); } };
    var update = function () {
      ticking = false;
      var s = slides(); var n = s.length; if (n < 2) return;
      var step = (s[1].offsetLeft - s[0].offsetLeft) || list.clientWidth || 1;
      var i = Math.max(0, Math.min(n - 1, Math.round(list.scrollLeft / step)));
      if (i === last) return;
      if (last !== -1) hideHint();
      last = i;
      cur.textContent = String(i + 1);
      if (dots.length) {
        var d = n <= dots.length ? i : Math.round(i * (dots.length - 1) / (n - 1));
        for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-on', k === d);
      }
    };
    list.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    list.addEventListener('touchmove', hideHint, { passive: true, once: true });
    update();
    if (hint && mq.matches) {
      var seen = false;
      try { seen = sessionStorage.getItem('ld_swipe_hint') === '1'; sessionStorage.setItem('ld_swipe_hint', '1'); } catch (e) {}
      if (!seen) { hint.hidden = false; setTimeout(hideHint, 4000); }
    }
  });

  /* ---------- 4. free-shipping line ---------- */
  var free = document.querySelector('.section-product-page [data-ld-free]');
  if (free) {
    var tpl = { gap: free.getAttribute('data-gap-html') || '', ok: free.getAttribute('data-ok-html') || '' };
    var threshold = +free.dataset.threshold || 0, minShow = +free.dataset.min || 0;
    var price = +free.dataset.price || 0, variant = free.dataset.variant || '', available = free.dataset.available === 'true';
    var text = free.querySelector('[data-ld-free-text]'), fill = free.querySelector('.ld-free__bar i');
    var fmt = function (cents) {
      return String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0') + '\u00a0Kč';
    };
    var render = function (cart) {
      var inCart = false;
      (cart.items || []).forEach(function (it) { if (String(it.variant_id) === String(variant)) inCart = true; });
      var total = (cart.total_price || 0) + (inCart ? 0 : price);
      var gap = threshold - total;
      var show = threshold > 0 && available && (gap <= 0 || price >= minShow || (cart.item_count || 0) > 0);
      free.hidden = !show;
      if (!show) return;
      free.classList.toggle('is-free', gap <= 0);
      text.innerHTML = gap <= 0 ? tpl.ok : tpl.gap.replace('[amount]', fmt(gap));
      fill.style.width = Math.min(100, Math.round(total / threshold * 100)) + '%';
    };
    var refresh = function () {
      fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); }).then(render).catch(function () {});
    };
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      [PUB_SUB_EVENTS.cartUpdate, PUB_SUB_EVENTS.cartAdd, PUB_SUB_EVENTS.cartRemove].forEach(function (ev) { subscribe(ev, refresh); });
      subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
        var v = ev && ev.data && ev.data.variant;
        if (!v) return;
        price = v.price; variant = String(v.id); available = !!v.available; refresh();
      });
    }
    /* the page may come from the browser's back/forward cache with an older cart */
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  }
})();
